import { ApiRequestError } from "./ApiRequestError";
import Cookies from "js-cookie";

export const CallApi = async (
  url: string,
  request: RequestInit,
  needAuth = true
) => {
  // Before request, check refresh token
  if (needAuth) {
    await CheckAccessToken();
  }

  const response = await fetch(url, request);
  if (!response.ok) {
    let message: string | undefined;
    try {
      message = (await response.json())?.message;
    } catch {
      // ignore parse error
    }
    throw new ApiRequestError(message, response.status);
  }
  return await response.json();
};

const CheckAccessToken = async () => {
  const tokenExpiration = Cookies.get("token_expiration");

  if (tokenExpiration == null) {
    // tokenが無いならエラーを出す
    //todo:将来的にエラーを出す
    return;
  }

  // access tokenが使えるなら有効期限内なのでそのまま終了
  if (parseInt(tokenExpiration) > Date.now() / 1000) {
    return;
  }

  // access tokenが切れてrefresh tokenが使えるなら取得し直す
  try {
    await CallApi(
      "/api_user/reauthentication",
      {
        credentials: "include",
        method: "POST",
      },
      false
    );
  } catch (e: any) {
    // 何らかの理由で更新できなかった
    if (e instanceof ApiRequestError) throw e;
    throw new ApiRequestError(e.message);
  }
};
